import { BaseEnum } from "../BaseEnum";

export class BalanceTypology extends BaseEnum {
  static REGISTERED = 1;
  static MANUAL = 2;

  static Codes = [this.REGISTERED, this.MANUAL];
  static _labelKeys = ["deposited", "manual"];
}
